module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.2d8452d4.png";